export const blockIconsNotificationOndemandVideo = (
	<span className='material-symbols-outlined'>ondemand_video</span>
);
